import React from "react";
import { Checkbox, FormControlLabel, Box } from "@mui/material";

import { IntlFormatUSD } from "../../../../../../utils";

interface IProps {
  isFilterByEmail: boolean;
  setIsFilterByEmail: (v: boolean) => void;
  chargesByEmail: string[];
  chargesIds: string[];
  chargesSum: number;
}
const MainInfo: React.FC<IProps> = ({
  isFilterByEmail,
  chargesByEmail,
  chargesIds,
  chargesSum,
  setIsFilterByEmail,
}) => {
  return (
    <div>
      <div>
        <b data-test="transactions-count">
          Total transactions: {isFilterByEmail ? chargesByEmail.length : chargesIds.length}
        </b>
      </div>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <div>
          <b data-test="transactions-sum">{chargesIds.length ? IntlFormatUSD(chargesSum) : 0}</b>
        </div>
        <div>
          <FormControlLabel
            control={
              <Checkbox
                checked={isFilterByEmail}
                onChange={() => setIsFilterByEmail(!isFilterByEmail)}
                name="isFilterByEmail"
              />
            }
            label="Filter transactions based on email"
          />
        </div>
      </Box>
    </div>
  );
};

export default MainInfo;
